// extracted by mini-css-extract-plugin
module.exports = {"countdown":"rk-z","srOnly":"sk-z"};